import React from "react";
import Header from "../Header";
import Footer from "../Footer";

interface WebTTMIProps {
  children: React.ReactNode;
}

const WebTTMI: React.FC<WebTTMIProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};

export default WebTTMI;